"use client";

import {JSX} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {useSnapshot} from "valtio";

import {ThingToDoCard} from "@/entities/destination/attraction/ui/thing-to-do-card/thing-to-do-card";

import {ButtonBase} from "@/shared/ui/buttons";
import {Typography} from "@/shared/ui/data-display/typography";
import {assetPath} from "@/shared/utils/asset-path";

import {type ThingsToDoInstance} from "../things-to-do.model";

import "./styles/things-to-do-list.scss";

type Props = {
    model: ThingsToDoInstance;
};

export function ThingsToDoList({model}: Props): JSX.Element {
    const snap = useSnapshot(model);

    const handleLoadMore = (): void => {
        model.loadMore();
    };

    if (snap.totalFilteredCount === 0) {
        return (
            <div className="things-to-do__empty">
                <Typography as="p" size={{desktop: 16, mobile: 14}} color="title">
                    Nothing found for the selected filters
                </Typography>
            </div>
        );
    }

    return (
        <>
            <div className="things-to-do__grid">
                {snap.visibleItems.map((item) => (
                    <ThingToDoCard key={item.id} {...item} />
                ))}
            </div>

            {snap.showLoadMoreButton ? (
                <div className="things-to-do__more">
                    <ButtonBase variant="secondary-outline" onClick={handleLoadMore} size="xs-s" width="fit">
                        Show More
                        <SmartImage
                            src={assetPath("/images/icons/arrow-black-down.svg")}
                            alt="Arrow"
                            width={12}
                            height={10}
                            className="things-to-do__arrow"
                        />
                    </ButtonBase>
                </div>
            ) : null}
        </>
    );
}
